import React, { useState } from "react";
import { MessageCircle, X, Send } from "lucide-react";
import api from "@/lib/api";

export default function ChatWidget() {
  const [open, setOpen] = useState(false);
  const [msgs, setMsgs] = useState([
    { from: "bot", text: "I'm Yasmin, your Atelier Noir concierge. Ask me about pieces, sizing, or our bespoke bag service." },
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [sessionId, setSessionId] = useState(null);

  const send = async (e) => {
    e?.preventDefault();
    if (!input.trim() || loading) return;
    const userMsg = input.trim();
    setMsgs((m) => [...m, { from: "user", text: userMsg }]);
    setInput("");
    setLoading(true);
    try {
      const { data } = await api.post("/ai/chat", { message: userMsg, session_id: sessionId });
      setSessionId(data.session_id);
      setMsgs((m) => [...m, { from: "bot", text: data.reply }]);
    } catch {
      setMsgs((m) => [...m, { from: "bot", text: "Apologies — please try again in a moment." }]);
    } finally { setLoading(false); }
  };

  return (
    <>
      <button
        data-testid="chat-toggle-button"
        onClick={() => setOpen((v) => !v)}
        className="fixed bottom-6 right-6 z-[60] bg-[#0A0A0A] text-white w-14 h-14 flex items-center justify-center rounded-full shadow-xl hover:bg-[#C5A059] transition-colors"
        aria-label="Open chat"
      >
        {open ? <X size={22} /> : <MessageCircle size={22} strokeWidth={1.5} />}
      </button>
      {open && (
        <div className="fixed bottom-24 right-6 z-[60] w-[360px] max-w-[calc(100vw-3rem)] h-[480px] bg-[#F5F5F0] border border-[#E5E5DF] shadow-2xl flex flex-col" data-testid="chat-widget">
          <div className="px-5 py-4 border-b border-[#E5E5DF] bg-white">
            <div className="serif text-xl">Concierge</div>
            <div className="text-[0.65rem] tracking-[0.25em] uppercase text-[#5A5A5A]">Yasmin • Atelier Noir</div>
          </div>
          <div className="flex-1 overflow-y-auto p-5 space-y-3">
            {msgs.map((m, i) => (
              <div key={i} className={`max-w-[85%] text-sm ${m.from === "user" ? "ml-auto bg-[#0A0A0A] text-white" : "bg-white border border-[#E5E5DF]"} px-4 py-3`}>
                {m.text}
              </div>
            ))}
            {loading && <div className="text-xs text-[#8A8A8A]">Yasmin is typing…</div>}
          </div>
          <form onSubmit={send} className="border-t border-[#E5E5DF] p-3 flex gap-2 bg-white">
            <input
              data-testid="chat-input"
              value={input} onChange={(e) => setInput(e.target.value)}
              placeholder="Ask about a piece…"
              className="flex-1 bg-transparent outline-none text-sm px-2"
            />
            <button data-testid="chat-send" type="submit" className="text-[#0A0A0A] hover:text-[#C5A059]"><Send size={18} /></button>
          </form>
        </div>
      )}
    </>
  );
}
